(() => {
  'use strict';

  if (window.__WIProductDescriptionLoaded) return;
  window.__WIProductDescriptionLoaded = true;

  const ROOT_SELECTOR = '[data-wi-product-part="description"]';
  const states = new WeakMap();

  function initProductDescription(root) {
    if (!root || states.has(root)) return;

    const videos = Array.from(root.querySelectorAll('.wi-pd__video'));
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    const saveData = connection?.saveData === true;
    const slowNetwork = ['slow-2g', '2g'].includes(
      connection?.effectiveType
    );
    const allowAutoplay =
      !reduceMotion && !saveData && !slowNetwork;

    const state = {
      videoObserver: null
    };

    if (!allowAutoplay) {
      videos.forEach((video) => {
        video.pause();
        video.removeAttribute('autoplay');
      });
    } else if ('IntersectionObserver' in window && videos.length) {
      state.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.12) {
              if (video.paused) {
                const playPromise = video.play();

                if (
                  playPromise &&
                  typeof playPromise.catch === 'function'
                ) {
                  playPromise.catch(() => {});
                }
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        {
          rootMargin: '48px 0px',
          threshold: [0, 0.12]
        }
      );

      videos.forEach((video) => {
        state.videoObserver.observe(video);
      });
    } else if (allowAutoplay) {
      videos.forEach((video) => {
        const playPromise = video.play();

        if (
          playPromise &&
          typeof playPromise.catch === 'function'
        ) {
          playPromise.catch(() => {});
        }
      });
    }

    state.destroy = () => {
      state.videoObserver?.disconnect();

      videos.forEach((video) => {
        if (!video.paused) video.pause();
      });

      states.delete(root);
    };

    states.set(root, state);
  }

  function initAll(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) {
      initProductDescription(scope);
    }

    scope
      .querySelectorAll?.(ROOT_SELECTOR)
      .forEach(initProductDescription);
  }

  initAll();

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const roots = event.target.matches?.(ROOT_SELECTOR)
      ? [event.target]
      : Array.from(
          event.target.querySelectorAll?.(ROOT_SELECTOR) || []
        );

    roots.forEach((root) => {
      states.get(root)?.destroy?.();
    });
  });
})();